import React from 'react';
import './Industries.css';
import { 
  ShoppingCart, 
  FirstAid, 
  Bank, 
  GraduationCap, 
  Buildings, 
  Truck,
  ArrowRight
} from '@phosphor-icons/react';

const industries = [
  {
    icon: <ShoppingCart size={40} weight="fill" />,
    image: "https://images.unsplash.com/photo-1557821552-17105176677c?q=80&w=1200",
    title: "Retail & E-Commerce",
    description: "Empowering retailers with conversion-optimized storefronts, AI-driven personalization, and seamless omnichannel experiences.",
    features: ["Headless Commerce", "Inventory Management", "Payment Integration"]
  },
  {
    icon: <FirstAid size={40} weight="fill" />,
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200",
    title: "Healthcare",
    description: "Building secure, HIPAA-compliant patient portals, telemedicine platforms, and advanced healthcare data management systems.",
    features: ["Patient Portals", "Data Encryption", "Remote Monitoring"]
  },
  {
    icon: <Bank size={40} weight="fill" />,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200",
    title: "Banking & FinTech",
    description: "Developing robust financial dashboards, secure payment gateways, and automated wealth management solutions.",
    features: ["API Integration", "Secure Transactions", "Financial Analytics"]
  },
  {
    icon: <GraduationCap size={40} weight="fill" />,
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1200",
    title: "Education & EdTech",
    description: "Creating interactive learning management systems (LMS), virtual classrooms, and student performance tracking tools.",
    features: ["LMS Development", "Virtual Classrooms", "Progress Tracking"]
  },
  {
    icon: <Buildings size={40} weight="fill" />,
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1200",
    title: "Real Estate",
    description: "Innovative property listing platforms, CRM for agents, and interactive virtual tour integrations for modern real estate.",
    features: ["Property Directories", "Lead Management", "Interactive Maps"]
  },
  {
    icon: <Truck size={40} weight="fill" />,
    image: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=1200",
    title: "Logistics & Supply",
    description: "Solving complex supply chain challenges with real-time tracking, fleet management, and automated inventory systems.",
    features: ["Fleet Tracking", "Order Management", "Route Optimization"]
  }
];

const Industries = () => {
  return (
    <section className="industries-page-section">
      <div className="industries-hero">
        <div className="industries-container">
          <span className="industry-tag">[ Sectors We Power ]</span>
          <h1>Expertise Across Diverse Industries</h1>
          <p className="industries-hero-desc">
            We specialize in building cutting-edge digital solutions tailored to the 
            unique demands and complexities of various high-growth industries.
          </p>
        </div>
      </div>

      <div className="industries-container">
        <div className="industries-grid">
          {industries.map((item, index) => (
            <div key={index} className="industry-card">
              <div className="industry-card-image">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  onError={(e) => {
                    e.target.src = "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1200";
                  }}
                />
              </div>
              <div className="industry-icon-wrapper">
                {item.icon}
              </div>
              <h3 className="industry-title">{item.title}</h3>
              <p className="industry-desc">{item.description}</p>
              
              <ul className="industry-features">
                {item.features.map((feat, i) => (
                  <li key={i}>
                    <ArrowRight size={14} weight="bold" />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
              
              <div className="card-glass-effect"></div>
            </div>
          ))}
        </div>
      </div>

      <div className="strategic-advantage">
        <div className="industries-container">
          <div className="advantage-grid">
            <div className="advantage-text">
              <span className="industry-tag">[ Strategic Advantage ]</span>
              <h2>Driving Innovation Through Sector-Specific Expertise</h2>
              <p>
                At Cabptoid, we don't just build software; we architect solutions that 
                understand the pulse of your specific industry. Our deep domain 
                knowledge ensures your digital transformation is both impactful and sustainable.
              </p>
              <div className="stats-row">
                <div className="stat-item">
                  <h3>150+</h3>
                  <p>Projects Delivered</p>
                </div>
                <div className="stat-item">
                  <h3>15+</h3>
                  <p>In-house Experts</p>
                </div>
                <div className="stat-item">
                  <h3>99%</h3>
                  <p>Client Satisfaction</p>
                </div>
              </div>
            </div>
            <div className="advantage-image">
              <img src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1200" alt="Innovation and Strategy" />
              <div className="image-overlay-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
